/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';

import { ElectroTooltip } from 'components/ExtendedUiElements/customized';

import styles from './AssetsCount.module.scss';

export type TypeProps = {
  assetsCount: number | string,
  assetsFilter: string,
};

@translate()
export default class AssetsCount extends React.PureComponent<*> {
  static defaultProps = {
    assetsCount: '-',
    assetsFilter: '/assets/id?params=assets',
  };

  render(): React.Element<*> {
    const { assetsCount, selected, t }: TypeProps = this.props;
    const isActive: boolean = selected ? styles.isActive : '';

    return (
      <span className={`${styles.assetsProjectCount} ${isActive}`}>
        <ElectroTooltip title={t('general:asset', { count: assetsCount })}>
          <span>
            <svg>
              <use xlinkHref="#icon-assets" />
            </svg>
            <strong>{assetsCount}</strong>
          </span>
        </ElectroTooltip>
      </span>
    );
  }
}
